module.exports = __webpack_public_path__ + "img/icon3.d7269d38.png";